<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <h4 class="page-title text-primary">Alle Touren</h4>
        </div>
      </div>
      <div class="page-rightheader">
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="openEditTrip(editTrip, 'new')"
          >Tour hinzufügen</a
        >
        <a class="btn btn-primary btn-pill" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
                    <div class="dropdown-menu border-0">
                            <a class="dropdown-item" id="dropdownToday" @click="setTimePicker('Today')">Letzte 24 Stunden</a>
                            <a class="dropdown-item" id="dropdownLastWeek" @click="setTimePicker('LastWeek')">Letzte 7 Tage</a>
                            <a class="dropdown-item active" id="dropdownLastMonth" @click="setTimePicker('LastMonth')">Letzte 30 Tage</a>
                            <a class="dropdown-item" id="dropdownAllTime" @click="setTimePicker('AllTime')">Gesamt</a>
                    </div>
      </div>
    </div>
    <div>
      <div>
        <input
          v-model="search"
          type="search"
          class="form-control form-control-sm"
          placeholder="Suche..."
          aria-controls="example1"
        />
        <br />
      </div>
      <div>
        <div>
          <div class="card">
            <!-- WAR FALSCH: Beim Zeitfilter "Letzte 24 Stunden"/"Letzte 7
                 Tage" war die Tabelle ohne jeden Hinweis leer — nichts
                 unterschied "hier liegt wirklich nichts" von "die Seite ist
                 kaputt". Gleiches Muster wie bei den Beiträgen (Posts.vue). -->
            <!--
              FEHLER 3: tripsError geht vor der Leermeldung. Wichtig: Der
              Server antwortet für Touren bei WIRKLICH null Treffern im
              gewählten Zeitraum bewusst mit HTTP 200 und success:false
              (tripController.js, allTripsWithLimit — NOT_FOUND ist dort die
              einzige Bedingung für eine Ablehnung). "Keine Touren im
              gewählten Zeitraum." ist für DIESEN Fall also weiterhin die
              richtige, ruhige Meldung — siehe fetchTrip(). tripsError deckt
              den ANDEREN Fall ab: einen echten Fehlschlag beim Abrufen selbst
              (Netz, HTTP), der bisher nur in der Konsole landete und genauso
              aussah wie "keine Touren".
            -->
            <div class="card-body text-center text-danger" v-if="tripsError">
              {{ tripsError }}
            </div>
            <div class="card-body text-center text-muted" v-else-if="tripsGeladen && trips.length === 0">
              Keine Touren im gewählten Zeitraum.
            </div>
            <div class="table-responsive" v-else>
              <table class="table card-table table-vcenter text-nowrap">
                <thead>
                  <tr>
                    <th>Bild</th>
                    <th>Name</th>
                    <th>Datum</th>
                    <th>Typ</th>
                    <th>Aktion</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="trip in trips" :key="trip._id">
                    <td class="align-middle">
                      <img
                        :src="`${$img(trip.image,$awsLargeImages)}`"
                        alt="img"
                        class="avatar avatar-md brround"
                        @error="handleImageError"
                      />
                    </td>
                    <td class="align-middle">{{ trip.title }}</td>
                    <td class="align-middle">{{$formatDate(trip.tripDate)}}</td>
                    <td class="align-middle">
											<div v-if="trip.category=='1 point'">1 Punkt</div>
											<div v-if="trip.category=='2 point'">2 Punkte</div>
										</td>
                    <td>
                      <a
                        title="Tour bearbeiten"
                        class="btn btn-primary btn-small mr-1"
                        @click="openEditTrip(trip, 'edit')"
                        ><i class="fas fa-edit"></i
                      ></a>
                      <a
                        title="Tour löschen"
                        class="btn btn-small btn-danger"
                        @click="openDeleteTrip(trip)"
                        ><i class="fas fa-trash-alt"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
        </div>

        <v-dialog v-model="editDialog" width="500">
          <v-card>
            <v-card-title class="card">
              <!-- WAR FALSCH: Der Titel stand fest auf "Tour bearbeiten" —
                   auch beim Anlegen über "Tour hinzufügen". Gleiches Muster
                   wie der Dialog-Titel in Events.vue. -->
              <h4 class="page-title text-primary">{{ editTrip.editType == 'new' ? 'Tour anlegen' : 'Tour bearbeiten' }}</h4>
            </v-card-title>
            <v-card-text>
              <div class="form-group">
                <label class="form-label">Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="editTrip.title"
                  v-bind:class="{
                    'is-invalid':
                      emptyValidation &&
                      (editTrip.title == null ||
                      editTrip.title == ''),
                  }"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Typ</label>
                <select
                  name=""
                  id=""
                  class="form-control"
                  v-model="editTrip.category"
                  v-bind:class="{
                    'is-invalid':
                      emptyValidation &&
                      (editTrip.category == null ||
                      editTrip.category == ''),
                  }"
                >
                  <option value="1 point">1 Punkt</option>
                  <option value="2 point">2 Punkte</option>
                  <option value="custom">Mehrere Zwischenstopps</option>
                </select>
              </div>

              <div class="form-group">
                <label class="form-label">Beschreibung</label>
                <textarea
                  rows="4"
                  class="form-control"
                  placeholder="Beschreibung"
                  v-bind:class="{
                    'is-invalid':
                      emptyValidation &&
                      (editTrip.description == null ||
                      editTrip.description == ''),
                  }"
                  v-model="editTrip.description"
                ></textarea>
              </div>
              <div class="form-group">
                <label class="form-label">Datum</label>
                <!-- WAR FALSCH (und inzwischen ZURÜCKGENOMMEN): Hier stand
                     eine Sperre gegen Termine in der Vergangenheit
                     (min-Attribut plus isPastDate() in der Feldprüfung).
                     Grund damals: Eine nachgetragene Tour war anschließend
                     nirgends mehr auffindbar, weil Liste und Suche vergangene
                     Termine ausblendeten. Genau diese Ursache ist seitdem im
                     Server behoben — ein Verwalter bekommt jetzt alle Touren,
                     auch vergangene (tripController.js: der Terminfilter gilt
                     nur noch für App-Nutzer). Die Sperre nahm dem Verwalter
                     damit eine Möglichkeit, die das System unterstützt (eine
                     Ausfahrt von letzter Woche nachtragen) — und das mit einer
                     irreführenden Begründung: Sie färbte nur das Feld rot, und
                     saveTrip() zählt lediglich, WIE VIELE Felder rot sind,
                     nicht warum. Der Verwalter las deshalb "alle
                     erforderlichen Felder ausfüllen", obwohl das Datum
                     ausgefüllt war. -->
                <input
                  type="date"
                  class="form-control"
                  placeholder=""
                  v-model="editTrip.tripDateObject"
                  v-bind:class="{
                    'is-invalid':
                      emptyValidation &&
                      (editTrip.tripDateObject == null ||
                      editTrip.tripDateObject == ''),
                  }"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Startpunkt</label>
                <GoogleMap
                  v-model="editTrip.startPointAddressObject"
                  :validated="emptyValidation && editTrip.startPointAddressObject ? true : false"
                />
                <!-- v-bind:validated="{true : emptyValidation && (editTrip.startPointAddressObject == null || editTrip.startPointAddressObject == '')}" -->
              </div>
              <div class="form-group" v-if="editTrip.category == '2 point'">
                <label class="form-label">Endpunkt</label>
                <GoogleMap
                  v-model="editTrip.endPointAddressObject"
                  :validated="emptyValidation && editTrip.endPointAddressObject ? true : false"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Maximale Teilnehmer</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder=""
                  v-model="editTrip.maxParticipants"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Bild</label>
                <div class="card overflow-hidden shadow-none border" v-if="this.editTrip.editType != 'new'">
                  <img
                    :src="`${$img(editTrip.image,$awsLargeImages)}`"
                    alt="image"
                    class="img-thumb"
                    @error="handleImageError"
                  />
                </div>
                <div class="card overflow-hidden shadow-none border" v-if="updatedPic">
                  <img
                    :src="updatedPic"
                    alt="image"
                    class="img-thumb"
                  />
                </div>
                <div class="input-group file-browser mb-5 mt-4">
                  <input
                    type="text"
                    id="imageFileDisplay"
                    class="form-control browse-file"
                    placeholder=""
                    readonly=""
                    v-bind:class="{'is-invalid': emptyValidation && checkFileInput() && (editTrip.image == null || editTrip.image == '')}"
                  />
                  <label class="input-group-text btn btn-primary">
                    Durchsuchen
                    <input
                      id="imageFile"
                      type="file"
                      class="file-browserinput"
                      style="display: none"
                      multiple=""
                      accept="image/png, image/jpeg"
                      v-on:change="setFileName()"
                    />
                  </label>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a
                class="btn btn-primary btn-pill mr-1"
                @click="editDialog = false"
                >Abbrechen</a
              >
              <a class="btn btn-primary btn-pill" @click="saveTrip()"
                >Speichern</a
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" width="500">
          <v-card>
            <v-card-title class="card">
              <h4 class="page-title text-primary">Tour löschen</h4>
            </v-card-title>
            <v-card-text>
              Sind Sie sicher, dass Sie diese Tour löschen wollen?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a
                class="btn btn-primary btn-pill mr-1"
                @click="deleteDialog = false"
                >Abbrechen</a
              >
              <a class="btn btn-danger btn-pill" @click="deleteTrip(editTrip)"
                >Löschen</a
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <v-dialog v-model="emptyDialog" width="300">
          <v-card>
            <br />
            <v-card-text>
              Alle Felder müssen ausgefüllt sein, um die Tour speichern zu
              können.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a
                class="btn btn-primary btn-pill mr-1"
                @click="emptyDialog = false"
                >Okay</a
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMap from "./widget/GoogleMap.vue";

export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      search: "",

      // Personal Data
      me: null,

      trips: [],
      // Steht auf false, solange die erste Antwort des Servers aussteht.
      // WAR FALSCH: Der Leerhinweis "Keine Touren im gewählten Zeitraum."
      // hing allein an trips.length === 0 — und das trifft auch WÄHREND des
      // Ladens zu. Auf einer langsamen Verbindung stand dort also erst die
      // Behauptung, es gebe keine Touren, und einen Augenblick später die
      // volle Tabelle. Der Hinweis erscheint jetzt erst, wenn wirklich eine
      // Antwort da ist.
      tripsGeladen: false,
      // Ein echter Abruf-Fehlschlag (Netz, HTTP) — siehe fetchTrip()/searchTrip()
      // und Kommentar im Template. Getrennt von "Keine Touren im gewählten
      // Zeitraum.", das der Server bewusst über success:false meldet.
      tripsError: '',
      editTrip: {},
      updatedPic: '',

      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
      emptyValidation: false,

      currentTimeSpan: 'LastMonth'
    };
  },

  name: "App",
  components: {
    GoogleMap,
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      if (this.search == "") {
        this.fetchTrip();
      } else {
        this.page = 0;
        this.searchTrip();
      }
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    }
  },

  mounted() {
    this.fetchTrip();
    if(this.$route.params.trip) {
      this.openEditTrip(this.$route.params.trip, 'edit');
    }
    this.$root.$on('Trips', (trip) => {
      this.openEditTrip(trip, 'edit');
    })
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                // WAR FALSCH: Es wurde nur weiter nachgeladen, wenn die letzte
                // Seite GENAU ElementPerPage Einträge lieferte. Bei "Letzte 24
                // Stunden"/"Letzte 7 Tage" antwortet der Server bei leerem
                // Ergebnis ohne das Feld "data" (siehe fetchTrip()) — außerdem
                // schneidet die Datenbankabfrage erst die Seite heraus, eine
                // Seite mit weniger als ElementPerPage Einträgen bedeutet also
                // nicht zwangsläufig "Ende der Liste". Jetzt wird
                // weitergeladen, solange die letzte Anfrage überhaupt etwas
                // geliefert hat.
                if(this.lastTrips > 0 || this.lastTrips == null){
                  console.log(this.page);
                  if(this.search ==  "" || this.search == null){
                    this.page++;
                    this.$axios
                          .get('/trip/all/' + this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
                          .then(function (response){
                            // Absicherung wie in fetchTrip(): bei leerem Ergebnis
                            // fehlt das Feld "data" ganz, ein blinder Zugriff auf
                            // .length riss hier sonst mit einem TypeError ab.
                            const data = (response.data && response.data.data) || [];
                            _this.lastTrips = data.length;
                            if(data.length >= 1) {
                              data.forEach(item => _this.trips.push(item));
                            }
                          })
                          .catch(this.onError);
                  }
                  else{
                    console.log('infinitesearch');
                    this.page++;
                    // Der Suchbegriff steht im Pfad und muss kodiert werden — ohne
                    // encodeURIComponent zerlegte ein "/" oder "?" im Suchtext die
                    // Route, das Nachladen lieferte dann einen Fehler statt Treffern.
                    this.$axios.get('/trip/search/' + encodeURIComponent(this.search) +'/'+ this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
                      // Gleiche Absicherung wie in searchTrip(): Die
                      // Such-Route liefert bei leerem Ergebnis ganz normal
                      // Erfolg mit data:[] (anders als die Liste in
                      // fetchTrip()) — eine Ablehnung ist hier also immer ein
                      // echter Fehlschlag, keine "keine Treffer"-Situation.
                      if (response.data == null || response.data.success === false) {
                        _this.tripsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
                        _this.onError(response.data);
                        return;
                      }
                      const data = response.data.data || [];
                      _this.lastTrips = data.length;
                      if(data.length >= 1) {
                        data.forEach(item => _this.trips.push(item));
                      }
                    }).catch(function(error){
                      _this.tripsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
                      _this.onError(error);
                    });
                  }
                }
            }, 500);
        }
    },
    fetchTrip() {
      var _this = this;
      // fetchTrip lädt immer ab Position 0, setzte aber den Seitenzähler nicht
      // zurück. Nach dem Scrollen sprang das nächste Nachladen deshalb mitten in
      // die Liste — beim Leeren der Suche und beim Wechsel des Zeitraums fehlten
      // dadurch alle Trips zwischen Seite 1 und der alten Seite.
      this.page = 0;
      this.tripsError = '';
      this.$axios
        .get("/trip/all/0/" + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
        .then(function (response) {
          // WAR FALSCH: Bei "Letzte 24 Stunden"/"Letzte 7 Tage" antwortet der
          // Server, wenn im Zeitraum nichts liegt, mit success:false OHNE das
          // Feld "data" — response.data.data war dann undefined. Die Tabelle
          // wurde damit unbemerkt auf undefined gesetzt, und die
          // anschließende .length-Abfrage brach mit einem TypeError ab, der
          // nur in der Browser-Konsole landete ("Letzte 24 Stunden" zeigte
          // dadurch eine leere Tabelle ohne jeden Hinweis).
          //
          // Das ist HIER bewusst weiterhin die "leer"-Behandlung und KEIN
          // sichtbarer Fehler: allTripsWithLimit im Backend liefert
          // success:false ausschließlich dann, wenn wirklich 0 Touren im
          // gewählten Zeitraum liegen (NOT_FOUND) — die Leermeldung im
          // Template ist für genau diesen Fall richtig. Ein ECHTER
          // Fehlschlag (Netz, HTTP, abgelehnte Anmeldung) landet dagegen im
          // .catch() unten und zeigt jetzt tripsError statt lautlos wie
          // "keine Touren" auszusehen.
          const data = (response.data && response.data.data) || [];
          _this.trips = data;
          _this.lastTrips = data.length;
          _this.tripsGeladen = true;
        })
        .catch(function (error) {
          // FEHLER 3: War nur console.error — ein echter Fehlschlag (Netz,
          // HTTP) sah dadurch genauso aus wie "keine Touren im gewählten
          // Zeitraum", der Verwalter bekam nie mit, dass der Abruf gar nicht
          // erst geklappt hat.
          _this.tripsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
          // Auch im Fehlerfall setzen: Sonst bliebe der Bildschirm dauerhaft
          // ohne Tabelle UND ohne Hinweis stehen.
          _this.tripsGeladen = true;
          _this.onError(error);
        });
    },
    searchTrip() {
      var _this = this;
      this.tripsError = '';
      this.$axios
        .get(
          // Suchbegriff kodieren: unkodiert brach ein "/" im Suchtext die Route
          // auf und die Suche lieferte einen Fehler statt Ergebnissen.
          "/trip/search/" +
            encodeURIComponent(this.search) +
            "/" +
            this.page +
            "/" +
            this.ElementPerPage
            + '/' + this.getCurrentTimeSpan()
        )
        .then(function (response) {
          // WAR FALSCH (FEHLER 3): response.data.data wurde ungeprüft in
          // trips und dessen .length in lastTrips geschrieben. Bei einer
          // Ablehnung (HTTP 200, success:false) fehlt data — trips wurde auf
          // undefined gesetzt, der .length-Zugriff warf DANACH mitten im
          // Erfolgszweig.
          //
          // ANDERS als in fetchTrip(): Die Such-Route (searchTrip im Backend)
          // hat KEIN "leer = success:false"-Verhalten — sie liefert bei
          // null Treffern ganz normal success mit data:[] (geprüft im
          // Quelltext, kein einziger respondFailure-Zweig in dieser
          // Backend-Funktion). Eine Ablehnung hier ist also immer ein
          // ECHTER Fehlschlag und wird sichtbar gemacht statt als "keine
          // Treffer" durchzugehen.
          if (response.data == null || response.data.success === false) {
            _this.tripsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
            _this.tripsGeladen = true;
            _this.onError(response.data);
            return;
          }
          _this.trips = response.data.data || [];
          _this.lastTrips = _this.trips.length;
          _this.tripsGeladen = true;
        })
        .catch(function (error) {
          _this.tripsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
          _this.tripsGeladen = true;
          _this.onError(error);
        });
    },
    // WAR FALSCH (FEHLER 3/7): Der Behandler schrieb nur in die
    // Entwicklerkonsole, die niemand offen hat. Zwei Formen kommen vor:
    // Axios-Fehler (Netz/HTTP) und der Antwortkörper eines fachlichen
    // Fehlschlags ({success:false, message:"…"} mit HTTP 200), den die
    // Aufrufer unten direkt hereinreichen. Gleiches Muster wie in
    // Users.vue/Reported.vue/Posts.vue.
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        // this.console gibt es nicht — der Fehlerbehandler warf hier selbst
        // und verdeckte damit die eigentliche Ursache.
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      this.$noty.error(this.failureMessage(err) || 'Die Anfrage ist fehlgeschlagen.');
    },
    // Liefert AUSSCHLIESSLICH den Klartext, den der Server geschickt hat —
    // sonst null. Gleiches Muster wie in Users.vue/Reported.vue/Posts.vue.
    failureMessage(err) {
      if (err == null) return null;
      if (err.response != null && err.response.data != null && err.response.data.message) {
        return err.response.data.message;
      }
      if (err.response == null && err.success === false && err.message) {
        return err.message;
      }
      return null;
    },
    // Fängt eine kaputte Bildadresse ab (Datei im Bildspeicher gelöscht,
    // Upload nur halb durchgelaufen). Ohne diesen Rückfall zeigte der
    // Browser in jeder betroffenen Tabellenzeile nur das zerbrochene
    // Bildsymbol.
    // WAR FALSCH (zweimal): Zuerst setzte die Bremse "event.target.onerror =
    // null" — das löscht nur die alte HTML-Eigenschaft onerror, die hier nie
    // benutzt wird. Die Vorlage meldet den Rückfall über "@error", Vue
    // registriert das intern per addEventListener; dieser Zuhörer blieb
    // aktiv, setzte bei einem scheiternden Ersatzbild erneut dieselbe
    // Adresse und drehte sich damit endlos im Kreis. Der zweite Anlauf
    // merkte sich den Rückfall dauerhaft am Bild-Element selbst
    // ("data-fallback-used"). Das bremste zwar die Schleife, galt aber für
    // IMMER: Die Tabellenzeilen haben einen festen Schlüssel (:key), Vue
    // verwendet dasselbe Bild-Element über jedes Neuladen der Liste hinweg
    // weiter. Lud der Verwalter danach ein neues, ebenfalls kaputtes Bild
    // hoch, bekam diese Zeile keinen Rückfall mehr und zeigte wieder das
    // zerbrochene Bildsymbol des Browsers. Jetzt wird nicht mehr gemerkt
    // "Rückfall schon einmal benutzt", sondern geprüft, ob die AKTUELLE
    // Adresse bereits das Ersatzbild ist — das bremst genau die echte
    // Schleife (das Ersatzbild scheitert selbst) und lässt jedes neue Bild
    // wieder zu.
    handleImageError(event) {
      const fallbackImage = '/images/brand/favicon.png';
      if (event.target.getAttribute('src') === fallbackImage) return;
      event.target.src = fallbackImage;
    },
    openEditTrip(trip, editType) {
      this.initializeTrip();
      if (editType == "edit") {
        // Hier stand `this.editTrip = trip;` — damit zeigte editTrip auf
        // GENAU DASSELBE Objekt wie die Tabellenzeile. Die beiden Zeilen
        // direkt darunter drehen die Koordinaten AN ORT UND STELLE für die
        // Kartenanzeige (Datenbank speichert [Länge, Breite], GoogleMap.vue
        // braucht [Breite, Länge] — siehe swapCoordinates() weiter unten).
        // FOLGE (gemessen): Ein Verwalter öffnete eine Tour, änderte NICHTS,
        // klickte Speichern — der bereits (für die Karte) gedrehte Stand
        // ging unverändert an den Server, weil die Rückdrehung beim
        // Speichern bisher nur für neu angelegte Touren passierte (siehe
        // saveTrip(), Zweig "new"). Die Tour landete dadurch an einer
        // völlig anderen Stelle der Erde. Gleiches Muster, gleicher Fix wie
        // openEditEvent() in Events.vue: eine echte tiefe Kopie anlegen,
        // damit weder die Tabellenzeile noch das Speichern-Objekt durch die
        // Kartendrehung verändert werden.
        // Nur die Felder übernehmen, die dieses Formular kennt und die das
        // Backend beim Speichern auch erlaubt (siehe validateUpdateOnePointTrip
        // / validateUpdateTwoPointTrip / validateUpdatecustomTrip in
        // ETSBackend). Die normale Liste (/trip/all/...) liefert ohnehin nur
        // diese Felder. Die globale Suche (/trip/search/...) liefert dagegen
        // den vollen Datenbank-Datensatz — u.a. galleryImages als TEXT "[]"
        // statt als echte Liste. Landete das ungefiltert in editTrip, lehnte
        // das Backend das Speichern mit 422 "galleryImages must be an array"
        // ab. Gleiches Muster, gleicher Fix wie openEditEvent() in Events.vue.
        // "stopOvers" gehoert mit in die Liste: Bei einer "custom"-Tour (mehrere
        // Zwischenstopps) fehlte das Feld hier bisher komplett. Damit ging beim
        // Bearbeiten kein stopOvers mit an den Server, das Backend erhielt
        // "undefined" und stuerzte beim Parsen ab (siehe tripController.js,
        // Zweig "custom" in updateTrip).
        const {
          _id, image, title, category, tripDate, description,
          startPointAddress, endPointAddress, maxParticipants, totalTripDistance,
          stopOvers,
        } = trip;
        this.editTrip = Object.assign({}, this.editTrip, JSON.parse(JSON.stringify({
          _id, image, title, category, tripDate, description,
          startPointAddress, endPointAddress, maxParticipants, totalTripDistance,
          stopOvers,
        })));
        // WAR FALSCH: Das Datumsfeld (type="date") kennt nur den Tag. Beim
        // Speichern wurde bisher NUR tripDateObject (JJJJ-MM-TT) als tripDate
        // verschickt — das Backend interpretierte das als Mitternacht und
        // überschrieb damit die ursprüngliche Uhrzeit, selbst wenn nur die
        // Beschreibung geändert wurde. FOLGE (gemessen): Aus einer Ausfahrt
        // um 17:00 Uhr wurde nach jeder Bearbeitung 00:00 Uhr. Die
        // ursprüngliche Uhrzeit wird hier gemerkt und beim Speichern wieder
        // angehängt (siehe saveTrip()).
        //
        // Die Trennstelle wird EINMAL bestimmt und geprüft: Fehlt das "T"
        // (indexOf liefert dann -1), ergab substring(0, -1) eine leere
        // Zeichenkette — das Datumsfeld wäre leer gewesen — und
        // substring(-1) die GANZE Zeichenkette. Beim Speichern wäre daraus
        // Tag + Tag geworden, also ein unbrauchbares Datum. Jetzt wird in
        // diesem Fall der Wert unverändert übernommen und kein Zeitanteil
        // gemerkt. Gleiches Vorgehen wie openEditEvent() in Events.vue.
        const tripTimeSeparator = trip.tripDate.indexOf("T");
        this.editTrip.tripDateObject = tripTimeSeparator > -1
          ? trip.tripDate.substring(0, tripTimeSeparator)
          : trip.tripDate;
        this.editTrip.tripTimePart = tripTimeSeparator > -1
          ? trip.tripDate.substring(tripTimeSeparator)
          : '';

        // Eigene, gedrehte Kopien NUR für die Kartenanzeige anlegen.
        // this.editTrip.startPointAddress/endPointAddress bleiben dabei in
        // der ursprünglichen, unangetasteten Datenbank-Reihenfolge stehen —
        // genau die Werte, die beim Speichern ohne Adressänderung
        // unverändert zurückgeschickt werden müssen (siehe saveTrip(),
        // Zweig "edit" weiter unten).
        this.editTrip.startPointAddressObject = JSON.parse(JSON.stringify(this.editTrip.startPointAddress));
        this.editTrip.startPointAddressObject.location.coordinates = this.swapCoordinates(this.editTrip.startPointAddress);

        this.editTrip.endPointAddressObject = JSON.parse(JSON.stringify(this.editTrip.endPointAddress));
        this.editTrip.endPointAddressObject.location.coordinates = this.swapCoordinates(this.editTrip.endPointAddress);
      }

      this.editDialog = true;
      this.editTrip.editType = editType;
      console.log(this.editTrip);
    },
    openDeleteTrip(trip) {
      this.editTrip = trip;
      this.deleteDialog = true;
    },

    saveTrip() {
      let _this = this;
      
      this.emptyValidation = true;
      this.$forceUpdate();


      Vue.nextTick(() => {
        if(document.getElementsByClassName('is-invalid').length > 0) {
          _this.emptyDialog = true;
          return;
        }
        const tripToSave = Object.assign({}, this.editTrip);
        tripToSave.tripId = tripToSave._id;
        tripToSave.tripDate = tripToSave.tripDateObject;
        // Die vom Datumsfeld gelieferte Zeichenkette enthält nur den Tag. Beim
        // Bearbeiten die zuvor gemerkte Uhrzeit (siehe openEditTrip()) wieder
        // anhängen, damit sie nicht stillschweigend auf Mitternacht springt.
        if (tripToSave.editType == 'edit' && tripToSave.tripTimePart) {
          tripToSave.tripDate = tripToSave.tripDateObject + tripToSave.tripTimePart;
        }

        if (tripToSave.editType == "new") {
          tripToSave.endPointAddress = this.copyAddress(
            tripToSave.endPointAddress,
            tripToSave.endPointAddressObject
          );
          tripToSave.startPointAddress = this.copyAddress(
            tripToSave.startPointAddress,
            tripToSave.startPointAddressObject
          );

          tripToSave.startPointAddress.location.coordinates =
            this.swapCoordinates(tripToSave.startPointAddress);
          if (tripToSave.category == "2 point") {
            tripToSave.endPointAddress.location.coordinates =
            this.swapCoordinates(tripToSave.endPointAddress);
            this.getTotalTripDistance(tripToSave.startPointAddress.place, tripToSave.endPointAddress.place, function(data){
              tripToSave.totalTripDistance = data;
              _this.saveTripToServer(tripToSave);
            });
            console.log(tripToSave.totalTripDistance);
            return; // Save already after getTotalTripDistance
          }
        } else {
          // Nur übernehmen, wenn über die Karte tatsächlich eine NEUE Adresse
          // gewählt wurde. GoogleMap.vue liefert bei einer Auswahl ein FLACHES
          // Objekt (coordinates direkt am Objekt, siehe getFormattedAddress in
          // widget/GoogleMap.vue). Ohne Änderung steht in
          // startPointAddressObject/endPointAddressObject weiterhin die beim
          // Öffnen angelegte, VERSCHACHTELTE Kopie (location.coordinates) ohne
          // oberflächliches .coordinates — die Prüfung lässt eine bestehende,
          // nicht angefasste Adresse dann unangetastet in der ursprünglichen
          // Datenbank-Reihenfolge stehen, statt sie mit dem für die Karte
          // gedrehten Stand zu überschreiben (der genau der oben behobene
          // Fehler war: einmal zu viel gedrehte Koordinaten in der Datenbank).
          if (tripToSave.startPointAddressObject && tripToSave.startPointAddressObject.coordinates) {
            tripToSave.startPointAddress = this.copyAddress(
              tripToSave.startPointAddress,
              tripToSave.startPointAddressObject
            );
            tripToSave.startPointAddress.location.coordinates =
              this.swapCoordinates(tripToSave.startPointAddress);
          }
          if (
            tripToSave.category == "2 point" &&
            tripToSave.endPointAddressObject &&
            tripToSave.endPointAddressObject.coordinates
          ) {
            tripToSave.endPointAddress = this.copyAddress(
              tripToSave.endPointAddress,
              tripToSave.endPointAddressObject
            );
            tripToSave.endPointAddress.location.coordinates =
              this.swapCoordinates(tripToSave.endPointAddress);
          }
        }

        // Gespeichert wurde bisher nur im Zweig "neu + 2 Punkte", weil der Aufruf
        // ausschließlich in der Rückruffunktion von getTotalTripDistance stand.
        // Bearbeiten und "neu + 1 Punkt" endeten ohne jeden Aufruf: Der Dialog
        // blieb offen und es wurde nichts gespeichert. Der 2-Punkte-Zweig steigt
        // oben mit return aus, hier kann also nicht doppelt gespeichert werden.
        _this.saveTripToServer(tripToSave);
      });
    },
    saveTripToServer(tripToSave){
      let _this = this;
      if(document.getElementsByClassName('is-invalid').length > 0) {
        this.emptyDialog = true;
        return;
      }

      var fileToUpload = null;
      if(document.getElementById('imageFile').files.length > 0 ) {
        if(((document.getElementById('imageFile').files[0].size/1024)/1024).toFixed(4) > 20) {
          this.$showErrorFileSize(20);
          return;
        }
        fileToUpload = document.getElementById('imageFile').files[0];
        delete tripToSave.image;
      }


      delete tripToSave._id;
      delete tripToSave.startPointAddressObject;
      delete tripToSave.endPointAddressObject;
      delete tripToSave.tripDateObject;
      delete tripToSave.tripTimePart;
      if (tripToSave.category == "1 point") {
        delete tripToSave.endPointAddress;
        delete tripToSave.totalTripDistance;
      }
      // stopOvers gehoert nur bei "custom"-Touren zur Anfrage (mehrere
      // Zwischenstopps). Bei "1 point"/"2 point" kennt das Backend-Schema
      // dieses Feld nicht und lehnt die Anfrage mit 422 ab, wenn es trotzdem
      // mitgeschickt wird.
      if (tripToSave.category != "custom") {
        delete tripToSave.stopOvers;
      }
      if (this.editTrip.editType == "new") {
        delete tripToSave.editType;
        delete tripToSave.tripId;
        const body = this.$formatUrlEncoded(tripToSave, fileToUpload);
        this.$axios
          .post("/trip/add", body)
          .then(function (response) {
            console.log(response.data);
            // HTTP 200 heisst hier nicht Erfolg: helpers/response.js im
            // Backend antwortet auch bei fachlichem Fehlschlag mit
            // Statuscode 200 und schreibt das Ergebnis nur in
            // `success`/`message`. Ohne diese Prüfung schloss sich der
            // Dialog trotzdem, der Verwalter sah "Erfolg", obwohl nichts
            // gespeichert wurde. Gleiches Muster wie saveEventToServer() in
            // Events.vue.
            // WAR FALSCH (FEHLER 7): success wurde zwar geprüft, gezeigt
            // wurde dann aber $showCommonError() ("Etwas ist schief
            // gelaufen") statt der eigentlichen Servermeldung — z. B. warum
            // genau das Anlegen abgelehnt wurde. Gleicher Stil wie in
            // Users.vue/Reported.vue: die Servermeldung selbst zeigen.
            if (response.data && response.data.success === false) {
              _this.onError(response.data);
              return;
            }
            _this.editDialog = false;
            // WAR FALSCH: Nach dem Anlegen fehlte der Aufruf, der die Liste
            // beim Server neu abholt (anders als im Bearbeiten-Zweig weiter
            // unten). Die Tabelle zeigte weiter den Stand vom letzten Laden —
            // die neue Tour tauchte erst nach einem manuellen Neuladen der
            // Seite auf, was leicht zu einem versehentlichen doppelten
            // Anlegen führte.
            _this.fetchTrip();
          })
          .catch(function (error) {
            _this.onError(error);
          });
      } else {
        delete tripToSave.editType;
        const body = this.$formatUrlEncoded(tripToSave, fileToUpload);
        this.$axios
          .put("/trip/update", body)
          .then(function (response) {
            console.log(response.data);
            // Gleicher Fall wie oben bei /trip/add: HTTP 200 mit
            // success:false ist ein fachlicher Fehlschlag, kein Erfolg. Ohne
            // diese Prüfung schloss sich der Dialog und die Liste lud neu,
            // obwohl nichts gespeichert wurde.
            // Gleicher Fall wie oben bei /trip/add: Servermeldung zeigen
            // statt der Allgemeinfloskel (FEHLER 7).
            if (response.data && response.data.success === false) {
              _this.onError(response.data);
              return;
            }
            _this.editDialog = false;
            // In einer function-Rückruffunktion ist "this" nicht die Komponente,
            // this.fetchTrip() warf deshalb einen Fehler und die Liste wurde nach
            // dem Bearbeiten nie neu geladen.
            _this.fetchTrip();
          })
          .catch(function (error) {
            _this.onError(error);
          });
      }

    },
    deleteTrip(trip) {
      // _this fehlte komplett: _this.deleteDialog warf einen ReferenceError, der
      // Dialog blieb nach dem Löschen offen. Zusätzlich zeigte this.fetchTrip()
      // in der function-Rückruffunktion nicht auf die Komponente, die Liste wurde
      // also nie aktualisiert.
      let _this = this;
      this.$axios
        .delete("/trip/delete/" + trip._id)
        .then(function (response) {
          console.log(response.data);
          // WAR FALSCH: Die Antwort wurde nicht auf "success" geprüft. Bei
          // einem bereits gelöschten oder nicht mehr vorhandenen Datensatz
          // antwortet das Backend mit success:false, aber weiterhin
          // Statuscode 200 — der Dialog schloss sich trotzdem und die Liste
          // lud "erfolgreich" neu, obwohl nichts gelöscht wurde.
          // FEHLER 7: Servermeldung zeigen statt der Allgemeinfloskel.
          if (response.data && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.deleteDialog = false;
          _this.fetchTrip();
        })
        .catch(function (error) {
          _this.onError(error);
        });

    },
    initializeTrip() {
      this.editTrip = {
        _id: "",
        image: "",
        title: "",
        // "category" fehlte hier als einziges Feld der Maske. Die Vorlage liest es
        // an zwei Stellen (Auswahlfeld "Typ" und v-if fuer den Endpunkt), und
        // saveTrip/saveTripToServer entscheiden daran, ob eine Endadresse
        // mitgeschickt wird. Ohne die Deklaration war editTrip.category bis zur
        // ersten Auswahl schlicht nicht vorhanden — die Maske beschrieb also
        // einen anderen Datensatz als der, der gespeichert wird.
        category: "",
        tripDate: "",
        tripDateObject: "",
        description: "",
        startPointAddress: {
          location: {
            coordinates: [],
          },
        },
        endPointAddress: {
          location: {
            coordinates: [],
          },
        },
        startPointAddressObject: {
          location: {
            coordinates: [],
          },
        },
        endPointAddressObject: {
          location: {
            coordinates: [],
          },
        },
        maxParticipants: "",
        editType: "",
        totalTripDistance: "",
      };
      this.updatedPic = '';
    },
    checkFileInput() {
      if(document.getElementById('imageFile').files.length == 0) {
        return true;
      }
      return false;
    },
    copyAddress(address, addressObject) {
      address.location.coordinates = addressObject.coordinates;
      address.city = addressObject.city;
      address.place = addressObject.place;
      address.country = addressObject.country;
      address.state = addressObject.state;

      return address;
    },
    swapCoordinates(Address) {
      const coordinates = [];
      coordinates.push(Address.location.coordinates[1]);
      coordinates.push(Address.location.coordinates[0]);

      return coordinates;
    },
    getTotalTripDistance(startPoint, endPoint, afterFunction = null) {
      let directionsService = new google.maps.DirectionsService();
      
      const route = {
        origin: startPoint,
        destination: endPoint,
        travelMode: 'DRIVING'
      }

      // need to wait for callback, how
      directionsService.route(route, function (response, status) {
        // anonymous function to capture directions
        if (status !== "OK") {
          console.log("Directions request failed due to " + status);
          return;
        } else {
          if(afterFunction !== null) {
            afterFunction(response.routes[0].legs[0].distance.value);
          }
        }
      });
    },
    setFileName() {
       let path = document.getElementById('imageFile').value;
       if(path) {
         var startIndex = path.lastIndexOf("\\");
         document.getElementById('imageFileDisplay').value = path.substring(startIndex + 1);
         this.updatedPic = URL.createObjectURL(document.getElementById('imageFile').files[0]);
       } else {
         document.getElementById('imageFileDisplay').value = '';
       }
    },
    setTimePicker(timeSpan) {
      console.log(timeSpan);
           let currentId = 'dropdown' + this.currentTimeSpan;
           let newId = 'dropdown' + timeSpan;

           document.getElementById(currentId).classList.remove('active');
           document.getElementById(newId).classList.add('active');

           this.currentTimeSpan = timeSpan;
           this.setCurrentTimeSpan(timeSpan);
       },
    setCurrentTimeSpan(timeSpan) {
      this.currentTimeSpan = timeSpan;
      this.fetchTrip();
    },
    getCurrentTimeSpan() {
      let time = -1;
      if(this.currentTimeSpan == 'Today') {
          time = 1;
      } else if (this.currentTimeSpan == 'LastWeek') {
          time = 7;
      } else if (this.currentTimeSpan == 'LastMonth') {
          time = 30;
      } else if (this.currentTimeSpan == 'AllTime') {
          time = -1;
      }

      return time;
    }
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>